import { SchoolAdminStudentsPage } from "./page"

export default SchoolAdminStudentsPage
